import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propBool, propFunc, propNumber, propStr, } from '../../../../../helpers/custom-prop-types';
const NextNav = (props) => {
    const { disabled, goNextStep, step, text } = props;
    const onClick = useCallback(() => {
        goNextStep(step);
    }, [goNextStep, step]);
    return (_jsx("div", Object.assign({ className: 'next-nav' }, { children: _jsx("button", Object.assign({ className: 'btn btn-primary btn-arrow-next', disabled: disabled, onClick: onClick, type: 'button' }, { children: text })) })));
};
NextNav.propTypes = {
    disabled: propBool().isRequired,
    goNextStep: propFunc().isRequired,
    step: propNumber().isRequired,
    text: propStr(),
};
NextNav.defaultProps = {
    text: '次へ進む',
};
export default NextNav;
